<template>
  <div class="main-daily app-container" v-loading="httpLoading">
    <div class="main-daily-title flex-between">
      <h1>团购商品</h1>
      <div class="all" @click="gotoCommodityPage">
        {{ $t('message.home.more' /**更多 */) }}
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="main-daily-content" ref="mainGroup">
      <EsProductView v-for="(item,index) in groupsList" :key="index + Math.random()" :item="item.goods" />
    </div>
    <!-- <swiper :options="swiperOptions">
      <swiper-slide v-for="(item, index) in list" :key="index">
        <div class="main-daily-item flex-center">
          <div class="img-content">
            <img :src="item" alt="" />
          </div>
          <span class="amount">$12.00</span>
        </div>
      </swiper-slide>
    </swiper> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EsProductView from '@/components/product'
import Bus from '@/util/bus'
import {
		group_list
	} from "@/api/marketing/group_marketing.js"
export default {
  name: 'EsMainGroup',
  components: { EsProductView },
  data() {
    return {
      httpLoading: false,
      groupQueryParams: {
					pageNumber: '1',
					pageSize: '5',
				},
      groupsList:[],
    }
  },
  computed: {
    ...mapGetters('home', ['newList']),
  },
  methods: {
    // ...mapActions('home', ['requestRecommendLList', 'requestRecommendNewLList']),
    gotoCommodityPage() {
      this.$router.push('/commodity')
    },
    async getList(){
      try {
      this.httpLoading = true
      // await this.requestRecommendNewLList({ type: 0 ,pageSize: 24,
      //     pageNum: 1,})
    } finally {
      this.$Gsap.from(this.$refs.mainDaily,{
        delay: 0.5,
        duration: 1,
        y: '+100',
        autoAlpha: 0,
        ease: "back.out(1.7)"
      })
      this.httpLoading = false
    }
    },
    	/**
			 * 查询列表 list
			 */
			group_list() {
				group_list(this.groupQueryParams).then(response => {
					this.groupsList = response.data.data;
				});
			},
  },
   mounted() {
    //  Bus.$on('cancelKeep', (id)=>{
    //     const i = this.newList.findIndex(x => x.id == id)
    //     if(i>-1){
    //         this.getList()
    //     }
    //   })
    //   Bus.$on('keepProduct', (id)=>{
    //     const i = this.newList.findIndex(x => x.id == id)
    //     if(i>-1){
    //         this.getList()
    //     }
    //   })
    // this.getList()
    this.group_list();
  },
}
</script>

<style lang="scss">
.main-daily {
  margin-bottom: 26px;
  &-title {
    h1 {
      font-weight: 700;
      font-size: 16px;
      color: var(--color-grey);
      margin: 24px 0;
    }
    span {
      color: var(--color-main);
      font-size: 12px;
    }
    .all {
      font-size: 12px;
      color: var(--color-main);
      cursor: pointer;
      font-weight: 400;
    }
  }
  &-item {
    flex-direction: column;
    .img-content {
      width: 100%;
      margin-bottom: 10px;
    }
    .amount {
      font-size: 16px;
      font-weight: 500;
      color: var(--color-main);
    }
  }
  &-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
    grid-column-gap: 14px;
    grid-row-gap: 20px;
    align-content: center;
    /* padding: 26px 0; */
  }
  // .swiper-container {
  //   cursor: pointer;
  //   font-size: 12px;
  //   img {
  //     max-width: 310px;
  //     max-height: 148px;
  //     object-fit: cover;
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
}
</style>
